import React from "react";
import { View } from "react-native";
import variables from "../../../../../styles/variables";
import RacecardRowLoader from "./RacecardRowLoader";

const { colors } = variables;

const RacesListAttachmentLoader = () => {
  return (
    <View>
      {[0, 1, 2, 3, 4].map((i: number) => (
        <View
          key={`body${i}`}
          style={
            i == 0
              ? { borderTopWidth: 0 }
              : {
                  borderTopWidth: 1,
                  borderTopColor: colors.palette.neutral.x100,
                  borderStyle: "solid",
                }
          }
        >
          <RacecardRowLoader />
        </View>
      ))}
    </View>
  );
};

export default RacesListAttachmentLoader;
